import React from 'react';

import { toast } from 'react-toastify';
import _ from 'lodash';

import 'react-toastify/dist/ReactToastify.css';

/**
 *
 * @param {string} content
 * @param {string} type - (info, success, warn, error, default, dark)
 * @param {string} position - (top-right, top-center, top-left, bottom-right, bottom-center, bottom-left)
 */
const Toast = (content, type, position = 'top-left') => {
  // snakeCase = top_left
  const snakeCaseStr = _.snakeCase(position);
  const POSITION = snakeCaseStr.toUpperCase();

  return toast[type](
    <div className="p-2" dir="rtl" style={toastStyle}>
      {content}
    </div>,
    { position: toast.POSITION[POSITION] }
  );
};

// Styles
const toastStyle = { fontFamily: 'IRANSans' };

export default Toast;
